import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a4a0fe38"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4a0fe38')) {
      api.createRecord('a4a0fe38', component.options)
    } else {
      api.reload('a4a0fe38', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a4a0fe38", function () {
      api.rerender('a4a0fe38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/skeletonTable/index.vue"
export default component.exports